
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/ui-components/PageTitle/PageTitle.vue';

@Component({
  name: 'CompanyProfilePage',
  components: {
    PageTitle
  },
})
export default class CompanyProfilePage extends Vue {
  
}
